import React, {
  PropsWithChildren,
  useContext,
  SVGProps,
  createContext,
} from 'react';
import { useSelector } from 'react-redux';
import { useCell } from '../hooks/useCell';
import { positionSelector } from '../selectors/cell.selectors';
import { CellId } from '../types/cell.type';
import { usePlot } from './plot.context';
import { RowContext } from './row.context';

interface Context {
  columnId: CellId;
  width: number;
  x: number;
}

export const ColumnContext = createContext<Context | null>(null);

type Props = PropsWithChildren<SVGProps<SVGSVGElement>> & {
  width: number;
  offsetLeft?: number;
};

export const Column: React.FC<Props> = ({
  children,
  width,
  offsetLeft,
  ...props
}) => {
  const { rootId } = usePlot();
  const parentId = useContext(RowContext)?.rowId ?? rootId;
  const columnId = useCell({ type: 'column', width, parentId });
  const { x } = useSelector(positionSelector(columnId));

  return (
    <ColumnContext.Provider value={{ columnId, x, width }}>
      {offsetLeft && <Column width={offsetLeft} />}
      {children && (
        <g className='column' transform={`translate(${x}, 0)`} {...props}>
          {children}
        </g>
      )}
    </ColumnContext.Provider>
  );
};
